import visible from './visible'

export default {
  install(Vue) {
    Vue.directive('visible', visible)
  },
}
